import _ from 'lodash'

const baseController = 'catalogosarticulos'

const baseIndex = baseController + '/index'

const unidadBaseOpts = [
    {
        value: '0',
        text: 'Unidad',
    },
    {
        value: '1',
        text: 'Miligramos',
    },
    {
        value: '2',
        text: 'Mililitros',
    },
    {
        value: '7',
        text: 'Litro',
    },
    {
        value: '8',
        text: 'Gramos',
    },
];

const archetype = [
     // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id_pk',
        type: 'hidden'
    },

    [
        {
            key: 'nombre',
            label: 'Articulo',
            // type: 'select',
            // options: []
        },
    ],

    [
        {
            key: 'unidadbase',
            label: 'Unidad base',
            type: 'select',
            options: unidadBaseOpts
        },

    ],
    
    [
        {
            key: 'id_padre_fk',
            label: 'Categoría',
            type: 'select',
            options: []
        },
    ], 

    null,

    [
        {
            key: 'clave_clase_division',
            label: 'División',
            type: 'select',
            options: []
        },
        {
            key: 'clave_clase_grupo',
            label: 'Grupo',
            type: 'select',
            options: []
        },
    ],

    null,

    [
        {
            key: 'clave_clase_clase',
            label: 'Clase',
            type: 'select',
            options: []
        },
        {
            key: 'clave_clase_pk',
            label: 'Clave',
            type: 'select',
            options: []
        },
    ]

    
];

const captions = [
    {key: 'nombre', label: 'Articulo', sortable: true},
    // {key: 'unidadbase', label: 'Unidad base'},
    {key: '_'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

let replaceUnidadBaseFromNum = value =>{
    let resp = _.find(unidadBaseOpts, {value})
    return resp.text
}

export {
    archetype,
    captions,
    baseIndex,
    automodalHandler,
    replaceUnidadBaseFromNum
}